import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import Print from "vue-print-nb";
import App from "./App.vue";
import appRegister from "./appRegister";
import directives from "./directives";
import i18n, { initI18n } from "./i18n";
import router from "./router";
import { setupRouterGuard } from "./routerGuard";
import store from "./store";

import "./element";

//引入nprogress
import "nprogress/nprogress.css";
import "@/assets/styles/index.css";
import "@/assets/styles/element-variables.scss";

Vue.config.productionTip = false;

// 注册全局指令
Vue.use(directives);
// 注册全局方法和组件
Vue.use(appRegister);

Vue.use(VueClipboard);

// 注册打印插件
Vue.use(Print);

const whiteList = ["/login", "/404"];

const createApp = async () => {
	const path = window.location.pathname;
	const token = localStorage.getItem("token");

	// 如果有token，且不在白名单中，则获取用户信息
	if (token && !whiteList.includes(path)) {
		// 获取用户权限
		await store.dispatch("user/getPermissions");
		// 获取用户信息
		await store.dispatch("user/getUserInfo");
	}

	await initI18n();

	return new Vue({
		router,
		store,
		i18n,
		render: (h) => h(App)
	}).$mount("#app");
};

// 路由守卫
setupRouterGuard(router, store);

const app = createApp();

export default app;
